export const locales = ["ar", "en"] as const;

export type PortalLocale = (typeof locales)[number];

export const defaultLocale: PortalLocale = "ar";
export const localeCookieName = "a2z-lang";
export const rtlLocales = new Set<PortalLocale>(["ar"]);
export const portalRoutingConfig = {
  locales: [...locales],
  defaultLocale,
  localeDetection: true,
} as const;

export function isSupportedLocale(value: string): value is PortalLocale {
  return locales.includes(value as PortalLocale);
}

export function getLocaleDirection(locale: PortalLocale) {
  return rtlLocales.has(locale) ? "rtl" : "ltr";
}

export function getLocaleFromAcceptLanguage(
  header: string | null,
): PortalLocale | null {
  if (!header) {
    return null;
  }

  const parts = header.split(",").map((part) => part.trim().toLowerCase());
  for (const part of parts) {
    const locale = part.split(";")[0]?.split("-")[0];
    if (locale && isSupportedLocale(locale)) {
      return locale;
    }
  }

  return null;
}
